/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Hubspot_RecordsInputs */

const en_nav_hubspot_records = /** @type {(inputs: Nav_Hubspot_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HubSpot records`)
};

/**
* | output |
* | --- |
* | "HubSpot records" |
*
* @param {Nav_Hubspot_RecordsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_hubspot_records = /** @type {((inputs?: Nav_Hubspot_RecordsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Hubspot_RecordsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_hubspot_records(inputs)
});